import moment from 'moment'
const formatDate = (value, format = 'DD/MM/YYYY') => {
    if (value) {
        return moment(String(value)).format(format)
    }
}

export default formatDate



// WEBPACK FOOTER //
// ./src/filters/format-date.js